import { render, staticRenderFns } from "./product-detail-dialog.vue?vue&type=template&id=2793ce98&scoped=true"
import script from "./product-detail-dialog.vue?vue&type=script&lang=js"
export * from "./product-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./product-detail-dialog.vue?vue&type=style&index=0&id=2793ce98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793ce98",
  null
  
)

export default component.exports